import React from "react";
import { Link } from "gatsby";

import { useShopData } from "../../data/shopData";

export interface LocaleLinkProps {
  activeClassName?: string;
  activeStyle?: object;
  partiallyActive?: boolean;
  style?: React.CSSProperties;
  replace?: boolean;
  className?: string;
  to: string;
  children: React.ReactNode;
  forceNoLocale?: boolean;
  stopPropagation?: boolean;
  onClick?: () => void;
}

export const LocaleLink = React.forwardRef<HTMLElement, LocaleLinkProps>((props, ref) => {
  const { locale, singleLocale } = STORYBOOK_ENV ? { locale: "", singleLocale: true } : useShopData();
  const { forceNoLocale, stopPropagation, onClick, ...rest } = props;
  const commonProps = {
    onClick: (e: React.MouseEvent<any>) => {
      if (stopPropagation) e.stopPropagation();
      onClick?.();
    },
    ref: ref as any,
  };
  if (singleLocale || !locale || forceNoLocale) return <Link {...commonProps} {...rest} />;
  return <Link {...commonProps} {...rest} to={`/${locale}${props.to}`} />;
});
